import React, { useEffect } from "react";
import "./SelfRevokeConfirmModal.css";

const SelfRevokeConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  orgName,
  isCurrentOrg,
  loading = false,
  userEmail,
}) => {
  const [emailInput, setEmailInput] = React.useState("");
  const [emailError, setEmailError] = React.useState(false);

  useEffect(() => {
    // Reset input when modal opens/closes
    if (isOpen) {
      setEmailInput("");
      setEmailError(false);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && !loading) {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleEsc);
      return () => window.removeEventListener("keydown", handleEsc);
    }
  }, [isOpen, onClose, loading]);

  const handleConfirm = () => {
    if (emailInput.trim().toLowerCase() !== userEmail.toLowerCase()) {
      setEmailError(true);
      return;
    }
    onConfirm();
  };

  const isEmailMatch =
    emailInput.trim().toLowerCase() === userEmail?.toLowerCase();

  if (!isOpen) return null;

  const displayName = orgName || "this organization";

  return (
    <div
      className="self-revoke-modal-overlay"
      onClick={!loading ? onClose : undefined}
    >
      <div className="self-revoke-modal" onClick={(e) => e.stopPropagation()}>
        <div className="self-revoke-modal-header">
          <h3>⚠️ Confirm Self-Revocation</h3>
        </div>

        <div className="self-revoke-modal-content">
          <p className="warning-text">
            You are about to revoke YOUR OWN access to {displayName}.
          </p>

          {isCurrentOrg && (
            <div className="redirect-warning">
              <p>
                <strong>Important:</strong> This is your currently selected
                organization.
              </p>
              <p>
                You will be immediately redirected to select a different
                organization.
              </p>
            </div>
          )}

          <div className="email-confirmation-section">
            <p className="confirm-text">
              To confirm, please type your email address:{" "}
              <strong>{userEmail}</strong>
            </p>
            <input
              type="email"
              className={`email-confirmation-input ${
                emailError ? "error" : ""
              }`}
              placeholder="Enter your email address"
              value={emailInput}
              onChange={(e) => {
                setEmailInput(e.target.value);
                setEmailError(false);
              }}
              disabled={loading}
              autoFocus
            />
            {emailError && (
              <p className="email-error-text">
                Email address does not match. Please try again.
              </p>
            )}
          </div>
        </div>

        <div className="self-revoke-modal-actions">
          <button
            type="button"
            onClick={onClose}
            className="cancel-button"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="confirm-revoke-button"
            disabled={loading || !isEmailMatch}
          >
            {loading ? "Revoking..." : "Yes, Revoke My Access"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelfRevokeConfirmModal;
